import { Component, Input, OnInit } from '@angular/core';
import { IContact } from '@osapp/model';
import { DrawerPopoverService } from '../../../shared/services/drawer-popover.service';

@Component({
  selector: 'di-selection-titulaire',
  templateUrl: './selection-titulaire.component.html',
  styleUrls: ['./selection-titulaire.component.scss'],
})
export class SelectionTitulaireComponent implements OnInit {

  @Input() handleClick: Function;
  @Input() facturation: boolean;
  @Input() infirmiers: IContact[] = [];
  public infirmierSelected: IContact;

  constructor(private svcDrawerPopover: DrawerPopoverService) { }

  ngOnInit() { }


  onClick() {
    if (!this.infirmierSelected) return;

    if (this.handleClick) {
      this.svcDrawerPopover.close();
      this.handleClick(this.infirmierSelected);
    }
  }


  cancel() {
    this.svcDrawerPopover.close();
  }

  onSelectionItem(infirmier: IContact) {
    this.infirmierSelected = infirmier;
  }

}
